import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import classNames from 'classnames'

import DropdownIndicator from './dropdown-indicator/DropdownIndicator'

import './community-select-field.scss'

const CommunitySelectField = (props) => {
  const {
    className,
    classNamePrefix,
    containerClassName,
    components,
    defaultValue,
    filterOption,
    formatOptionLabel,
    isClearable,
    isMulti,
    noOptionsMessage,
    options,
    searchable,
    useObjectValue,
    cashSelectedOption,
    onChange,
    value,
  } = props

  const [selectedOption, setSelectedOption] = useState(null)

  const onFieldChange = (option) => {
    if (useObjectValue) {
      onChange(option)
    } else {
      if (cashSelectedOption) {
        setSelectedOption(option)
      }
      onChange(option?.value)
    }
  }

  // Use saved selectedOption to avoid find on every change
  let selectValue = selectedOption && !useObjectValue ? selectedOption : value
  let selectDefaultValue = defaultValue
  // Set option object as value
  if (typeof selectValue === 'string' || typeof selectValue === 'number') {
    selectValue = options.find((option) => String(option.value) === String(selectValue))
  }
  // Set option object as default value
  if (selectDefaultValue && (typeof selectDefaultValue === 'string' || typeof selectValue === 'number')) {
    selectDefaultValue = options.find((option) => String(option.value) === String(selectValue))
  }
  const fieldContainerClassNames = classNames('community-select-container', containerClassName)
  const fieldClassNames = classNames('community-select-field', className)

  return (
    <div className={fieldContainerClassNames}>
      <Select
        className={fieldClassNames}
        defaultValue={selectDefaultValue}
        isSearchable={searchable}
        onChange={onFieldChange}
        value={selectValue || ''}
        noOptionsMessage={() => noOptionsMessage}
        menuPlacement='auto'
        valueKey='tags'
        {...{
          classNamePrefix,
          components,
          filterOption,
          formatOptionLabel,
          isClearable,
          isMulti,
          options,
        }}
      />
    </div>
  )
}

CommunitySelectField.displayName = 'CommunitySelectField'
CommunitySelectField.propTypes = {
  cashSelectedOption: PropTypes.bool,
  className: PropTypes.string,
  classNamePrefix: PropTypes.string,
  containerClassName: PropTypes.string,
  components: PropTypes.shape({
    ClearIndicator: PropTypes.elementType,
    DropdownIndicator: PropTypes.elementType,
  }),
  defaultValue: PropTypes.string,
  filterOption: PropTypes.func,
  formatOptionLabel: PropTypes.func,
  isClearable: PropTypes.bool,
  isMulti: PropTypes.bool,
  noOptionsMessage: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.any,
    })
  ),
  searchable: PropTypes.bool,
  useObjectValue: PropTypes.bool,
  valid: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.any,
    }),
  ]),
  valueKey: PropTypes.string,
}

CommunitySelectField.defaultProps = {
  cashSelectedOption: true,
  classNamePrefix: 'community-select-field',
  components: {
    DropdownIndicator,
  },
  isClearable: false,
  options: [],
  searchable: true,
  useObjectValue: false,
  valid: true,
}

export default CommunitySelectField
